import { Controller } from "web-ui/controller"
import * as Log from "web-ui/log"

// Connects to data-controller="view-form-error"
export default class extends Controller {
  connect() {
    this.debug("Connect")
  }

  disconnect() {
    this.debug("Disconnect")
  }

  viewError() {
    const invalidField = document.querySelector("form .field.invalid, form .message.error")

    if (invalidField) {
      invalidField.scrollIntoView({ behavior: "smooth", block: "center" })

      const input = invalidField.querySelector("input, textarea, select")

      if (input) {
        input.focus({ preventScroll: true })
      }
    }
  }

  debug(message, data) {
    Log.debug("View Form Error - " + message, data)
  }
}
